import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const hutchConfig: TSPConfig = {
  key: 'hutch',
  name: 'Hutch',
  category: TSPCategory.API_KEY,
  helpText: 'Please request an API key from your Hutch representative.',
  loginComponent: (props) => (
    <LoginCreds
      fields={[{ name: 'apikey', label: 'Enter API key' }]}
      onValidityChange={props.onValidityChange}
    />
  ),
};

export default hutchConfig;
